import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {MyHospitalizationFlowEnum} from 'presentation/constants';
import {EmptyStateHospitalizationType} from './types';
import {StyledContainer} from './styles';

const {goBack} = translations['pt-br'].commons;

export const EmptyStateHospitalization = ({
	iconName,
	title,
	description,
}: EmptyStateHospitalizationType) => {
	const navigate = useNavigate();
	return (
		<StyledContainer>
			<IconIllustration variant="default" customIconName={iconName} />
			<Stack alignItems={'center'} textAlign={'center'}>
				<Typography color={'text.primary'} variant="h6">
					{title}
				</Typography>
				<Typography color={'text.primary'} variant="body1">
					{description}
				</Typography>
			</Stack>

			<Button
				size="large"
				fullWidth
				sx={{maxWidth: '300px'}}
				onClick={() => navigate(MyHospitalizationFlowEnum.HOME)}>
				{goBack}
			</Button>
		</StyledContainer>
	);
};
